import type { StartFlowParams } from "@hooks/useAccountConnectionFlow";

/**
 * Chat 结果页 / ETF 不足页里的「连账户卡」走重叠链路时给 `startFlow` 追加的参数（EDG-561 AC-5.2~5.4）：
 * 不出付费墙、绑定成功不弹 AccountReadPending、`plaid_link_*` 带 `entry=overlap_result`、
 * 流程内改为上传时落到重叠版上传页（`from=request_card`）。
 */
export const OVERLAP_REQUEST_CARD_FLOW_PARAMS: Pick<
  StartFlowParams,
  | "skipPaywall"
  | "suppressAccountReadPending"
  | "plaidTrackingContext"
  | "uploadEntry"
  | "uploadFrom"
> = {
  skipPaywall: true,
  suppressAccountReadPending: true,
  plaidTrackingContext: { entry: "overlap_result" },
  uploadEntry: "overlap",
  uploadFrom: "request_card",
};
